import { createJSONRequest } from '../../../api/create-request.js'
import { Policy } from '@/Domain/Policy/Enums/enums'

export const fetchPolicyPage = (type: Policy) => createJSONRequest({
  method: 'GET',
  url: `/api/policies/${type}`,
})

export const updatePolicyPage = (type: Policy, data: String) => createJSONRequest({
  method: 'PUT',
  url: `/api/policies/${type}`,
  data: data,
})
